class PawtyProductGallery extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.dialog = this.querySelector('[data-gallery-dialog]');
    this.dialogImage = this.querySelector('[data-gallery-dialog-image]');
    this.current = 0;
    this.touchStart = null;
    this.didSwipe = false;

    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.current - 1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.current + 1));
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.show(Number(thumb.dataset.index))));
    this.slides.forEach((slide) => slide.addEventListener('click', (event) => {
      if (this.didSwipe) {
        event.preventDefault();
        return;
      }
      this.open(slide);
    }));
    this.addSwipeNavigation(this.querySelector('.pawty-product-gallery__stage'));
    this.addSwipeNavigation(this.dialog, true);
    this.querySelector('[data-gallery-close]')?.addEventListener('click', () => this.dialog?.close());
    this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
  }

  show(index) {
    if (!this.slides.length) return;
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.hidden = i !== this.current;
      slide.classList.toggle('is-active', i === this.current);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === this.current);
      thumb.setAttribute('aria-current', i === this.current ? 'true' : 'false');
    });
    const activeThumb = this.thumbs[this.current];
    if (activeThumb && window.matchMedia('(max-width: 749px)').matches) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    if (this.dialog?.open) this.updateDialogImage();
  }

  open(slide) {
    const image = slide.querySelector('img');
    if (!image || !this.dialog || !this.dialogImage) return;
    this.current = Number(slide.dataset.index || 0);
    this.updateDialogImage();
    this.dialog.showModal();
  }

  updateDialogImage() {
    const image = this.slides[this.current]?.querySelector('img');
    if (!image || !this.dialogImage) return;
    this.dialogImage.src = image.currentSrc || image.src;
    this.dialogImage.alt = image.alt || '';
  }

  addSwipeNavigation(target, fullscreen = false) {
    if (!target) return;
    target.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      this.touchStart = { x: touch.clientX, y: touch.clientY };
      this.didSwipe = false;
    }, { passive: true });
    target.addEventListener('touchend', (event) => {
      if (!this.touchStart || this.slides.length < 2) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - this.touchStart.x;
      const deltaY = touch.clientY - this.touchStart.y;
      this.touchStart = null;
      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
      this.didSwipe = true;
      this.show(this.current + (deltaX < 0 ? 1 : -1));
      if (fullscreen) this.updateDialogImage();
      window.setTimeout(() => { this.didSwipe = false; }, 350);
    }, { passive: true });
  }
}

if (!customElements.get('pawty-product-gallery')) customElements.define('pawty-product-gallery', PawtyProductGallery);
